// extracted by mini-css-extract-plugin
module.exports = {"select-item":"select-sorter_select-item__4IDl_","select":"select-sorter_select__mnJ_i"};